import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  locale?: 'th_TH' | 'en_US';
  keywords?: string;
  canonical?: string;
  robots?: string;
}

const DEFAULT_TITLE = 'HappyTech - รับทำเว็บ แอป และระบบให้ธุรกิจ';
const DEFAULT_DESCRIPTION = 'HappyTech รับทำเว็บ แอป และระบบให้ธุรกิจไทย พร้อมให้คำปรึกษาด้านเทคนิค ดูแลครบจนเปิดใช้งานได้จริง';
const DEFAULT_IMAGE = 'https://www.happytech.dev/og-image.jpg';
const DEFAULT_URL = 'https://www.happytech.dev';

export function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url = DEFAULT_URL,
  type = 'website',
  locale = 'th_TH',
  keywords,
  canonical,
  robots = 'index, follow',
}: SEOProps) {
  const fullTitle = title ? `${title} | HappyTech` : DEFAULT_TITLE;
  const canonicalUrl = canonical || url;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Meta Robots */}
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={locale} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
